/* CollecteAvis — champ « pour quel commerce ? » des fiches produit. Refonte 2026-10.
   - Google Maps n'est chargé qu'au premier toucher du champ.
   - Le commerce choisi part avec la commande (propriétés de ligne) ; l'achat sans choix est retenu avec un message.
   - Après un ajout au panier : « + Ajouter une plaque pour un autre commerce ». */
/* Moment signature : boucle lente seulement quand la scène est visible ; bouton pause (WCAG 2.2.2). */
(function () {
  var scene = document.querySelector('[data-ca-scene]');
  if (!scene || !('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var bouton = scene.querySelector('[data-ca-scene-pause]');
  var enPause = false;
  scene.classList.add('is-anime');
  new IntersectionObserver(function (e) {
    scene.classList.toggle('is-pause', enPause || !e[0].isIntersecting);
  }).observe(scene);
  bouton.addEventListener('click', function () {
    enPause = !enPause;
    scene.classList.toggle('is-pause', enPause);
    bouton.setAttribute('aria-pressed', enPause ? 'true' : 'false');
    bouton.setAttribute('aria-label', enPause ? 'Relancer l’animation' : 'Mettre l’animation en pause');
  });
})();

(function () {
  'use strict';

  var racine = document.querySelector('[data-ca-commerce]');
  var form = document.querySelector('product-form form[action*="/cart/add"]');
  if (!racine || !form) return;

  var produitForm = form.closest('product-form');
  var champ = racine.querySelector('[data-champ]');
  var liste = racine.querySelector('[data-liste]');
  var erreur = racine.querySelector('[data-erreur]');
  var cle = racine.getAttribute('data-cle');
  var choix = null;
  var autocompletion = null;
  var details = null;
  var jeton = null;
  var minuterie = null;
  var actif = -1;
  var NOMS = { nom: 'properties[Commerce]', adresse: 'properties[Adresse]', lien: 'properties[_Lien avis]' };

  function etat(nom) {
    racine.setAttribute('data-etat', nom);
  }

  function poser(c) {
    form.querySelectorAll('input[data-ca-prop]').forEach(function (i) { i.remove(); });
    choix = c;
    if (!c) return;
    Object.keys(NOMS).forEach(function (k) {
      if (!c[k]) return;
      var i = document.createElement('input');
      i.type = 'hidden';
      i.name = NOMS[k];
      i.value = c[k];
      i.setAttribute('data-ca-prop', '');
      form.appendChild(i);
    });
    erreur.hidden = true;
  }

  function montrerChoix(c) {
    poser(c);
    racine.querySelector('[data-choisi-nom]').textContent = c.nom;
    racine.querySelector('[data-choisi-adresse]').textContent = c.note || c.adresse || '';
    etat('choisi');
  }

  /* Google Maps, chargé à la demande */
  var mapsPret = null;
  function chargerMaps() {
    if (mapsPret) return mapsPret;
    mapsPret = new Promise(function (ok, ko) {
      if (window.google && google.maps && google.maps.places) return ok();
      window.caMapsPret = function () { ok(); };
      var s = document.createElement('script');
      s.src = 'https://maps.googleapis.com/maps/api/js?key=' + encodeURIComponent(cle) +
        '&libraries=places&language=fr&callback=caMapsPret';
      s.async = true;
      s.onerror = function () { mapsPret = null; ko(); };
      document.head.appendChild(s);
    });
    return mapsPret;
  }

  function fermerListe() {
    liste.hidden = true;
    liste.innerHTML = '';
    champ.setAttribute('aria-expanded', 'false');
    champ.removeAttribute('aria-activedescendant');
    actif = -1;
  }

  function afficher(predictions) {
    liste.innerHTML = '';
    actif = -1;
    if (!predictions || !predictions.length) return fermerListe();
    predictions.slice(0, 5).forEach(function (p, n) {
      var li = document.createElement('li');
      var f = p.structured_formatting || {};
      li.id = 'ca-commerce-option-' + n;
      li.setAttribute('role', 'option');
      li.setAttribute('aria-selected', 'false');
      li.textContent = f.main_text || p.description;
      if (f.secondary_text) {
        var s = document.createElement('small');
        s.textContent = f.secondary_text;
        li.appendChild(s);
      }
      li.addEventListener('mousedown', function (e) { e.preventDefault(); choisir(p); });
      liste.appendChild(li);
    });
    liste.hidden = false;
    champ.setAttribute('aria-expanded', 'true');
  }

  function choisir(p) {
    fermerListe();
    if (!details) details = new google.maps.places.PlacesService(document.createElement('div'));
    details.getDetails(
      { placeId: p.place_id, fields: ['name', 'formatted_address', 'place_id'], sessionToken: jeton },
      function (lieu, statut) {
        jeton = null;
        if (statut !== google.maps.places.PlacesServiceStatus.OK || !lieu) return;
        montrerChoix({
          nom: lieu.name,
          adresse: lieu.formatted_address,
          lien: 'https://search.google.com/local/writereview?placeid=' + lieu.place_id
        });
      }
    );
  }

  function surligner(n) {
    var items = liste.querySelectorAll('li');
    if (!items.length) return;
    actif = (n + items.length) % items.length;
    items.forEach(function (li, i) { li.setAttribute('aria-selected', i === actif ? 'true' : 'false'); });
    champ.setAttribute('aria-activedescendant', items[actif].id);
  }

  champ.addEventListener('focus', function () { chargerMaps().catch(function () {}); });

  champ.addEventListener('input', function () {
    var texte = champ.value.trim();
    clearTimeout(minuterie);
    if (texte.length < 2) return fermerListe();
    minuterie = setTimeout(function () {
      chargerMaps().then(function () {
        if (!autocompletion) autocompletion = new google.maps.places.AutocompleteService();
        if (!jeton) jeton = new google.maps.places.AutocompleteSessionToken();
        autocompletion.getPlacePredictions(
          { input: texte, types: ['establishment'], componentRestrictions: { country: ['fr', 'be'] }, sessionToken: jeton },
          afficher
        );
      }).catch(function () { etat('main'); });
    }, 250);
  });

  champ.addEventListener('keydown', function (e) {
    if (liste.hidden) return;
    if (e.key === 'ArrowDown') { e.preventDefault(); surligner(actif + 1); }
    else if (e.key === 'ArrowUp') { e.preventDefault(); surligner(actif - 1); }
    else if (e.key === 'Enter' && actif > -1) {
      e.preventDefault();
      liste.querySelectorAll('li')[actif].dispatchEvent(new MouseEvent('mousedown', { cancelable: true }));
    } else if (e.key === 'Escape') { fermerListe(); }
  });
  champ.addEventListener('blur', function () { setTimeout(fermerListe, 150); });

  racine.querySelector('[data-ouvrir-main]').addEventListener('click', function () {
    etat('main');
    racine.querySelector('[data-main-nom]').focus();
  });

  racine.querySelector('[data-valider-main]').addEventListener('click', function () {
    var nom = racine.querySelector('[data-main-nom]').value.trim();
    var ville = racine.querySelector('[data-main-ville]').value.trim();
    if (nom.length < 2) { racine.querySelector('[data-main-nom]').focus(); return; }
    montrerChoix({ nom: nom, adresse: ville || 'Ville à préciser' });
  });

  racine.querySelector('[data-plus-tard]').addEventListener('click', function () {
    montrerChoix({
      nom: 'À préciser sur WhatsApp',
      adresse: 'Pas encore de fiche Google',
      note: 'On vous écrit sur WhatsApp après la commande pour régler ça ensemble.'
    });
  });

  function recommencer() {
    poser(null);
    champ.value = '';
    etat('recherche');
    champ.focus();
  }
  racine.querySelector('[data-changer]').addEventListener('click', recommencer);
  racine.querySelector('[data-autre]').addEventListener('click', recommencer);

  /* Pas d'achat sans commerce : on retient l'envoi et on montre le champ (avant le gestionnaire de Dawn). */
  produitForm.addEventListener('submit', function (e) {
    if (choix) return;
    e.preventDefault();
    e.stopPropagation();
    erreur.hidden = false;
    racine.scrollIntoView({ behavior: 'smooth', block: 'center' });
    (racine.getAttribute('data-etat') === 'main' ? racine.querySelector('[data-main-nom]') : champ).focus({ preventScroll: true });
  }, true);

  /* Après l'ajout au panier (événement de Dawn) */
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (ev) {
      if (!ev || ev.source !== 'product-form' || !choix) return;
      racine.querySelector('[data-ajoute-nom]').textContent = choix.nom;
      poser(null);
      etat('ajoute');
    });
  }
})();

/* Description : enveloppe l'accroche et la phrase de fin pour l'effet « lecture qui s'allume » (CSS). */
(function () {
  document.querySelectorAll('.product__description .ca-desc__accroche, .product__description .ca-desc__fin').forEach(function (p) {
    if (p.querySelector('.ca-desc__lit')) return;
    var s = document.createElement('span'); s.className = 'ca-desc__lit';
    while (p.firstChild) s.appendChild(p.firstChild);
    p.appendChild(s);
  });
})();
